import { signal } from "@preact/signals";

const KEY = "obean:sound";

function stored(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true; // storage off (private windows): on, for this page
  }
}

/** The player's sound setting, kept in this browser (P2-TANK-08): on unless they muted it. */
export const soundOn = signal(stored());

export function setSoundOn(on: boolean): void {
  soundOn.value = on;
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    // Storage off: the setting lasts for this page only.
  }
}

/** The game's master volume: quiet by default (founder, 2026-10-06). */
export const SOUND_VOLUME = 0.35;
